export class Password{
  constructor(password, changePassword, changePasswordConfirm){
    this.password = password;
    this.changePassword = changePassword;
    this.changePasswordConfirm = changePasswordConfirm;
  }
}